/* tslint:disable */
/* eslint-disable */
/**
 * Stotles Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeadSignal
 */
export interface LeadSignal {
    /**
     * 
     * @type {string}
     * @memberof LeadSignal
     */
    category: string;
    /**
     * 
     * @type {string}
     * @memberof LeadSignal
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof LeadSignal
     */
    colour: string;
}

/**
 * Check if a given object implements the LeadSignal interface.
 */
export function instanceOfLeadSignal(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "category" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "colour" in value;

    return isInstance;
}

export function LeadSignalFromJSON(json: any): LeadSignal {
    return LeadSignalFromJSONTyped(json, false);
}

export function LeadSignalFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadSignal {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'category': json['category'],
        'name': json['name'],
        'colour': json['colour'],
    };
}

export function LeadSignalToJSON(value?: LeadSignal | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'category': value.category,
        'name': value.name,
        'colour': value.colour,
    };
}

